import React, { Fragment } from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
  InputNumber,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import FileLink from "../FileLink/FileLink";

import {
  updateDocumentRequest,
  createDocumentRequest,
  createPatientProfileDocumentRequest,
  getSitesRequest,
  updatePatientProfileDocumentRequest,
} from "../../api/requests";
import {
  getDocumentCreatePermission,
  getDocumentUpdatePermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getDocumentPerSiteReadPermission,
  getDocumentGeneralPrivateReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentValidationReadPermission,
} from "../../reducers/user/selectors";

import classes from "./DocumentForm.css";
import { logout } from "../../reducers/user/actions";
import moment from "moment";

const { Option } = Select;

export const documentTypes = {
  // Site Specific category
  site_accreditation: "Site accreditation",
  doctor_license: "Professional/Medical license",
  training_completion_certificate: "Training Completion Certificate",
  cv: "CV",
  gcp_certificates: "GCP Certificates",
  reb_ethics_approval_letter:
    "REB/Ethics approval letter, annual renewals, amendments",
  ethics_membership_list: "Ethics Membership List",
  reb_ethics_correspondence: "REB/Ethics Correspondence",
  approved_consent_form:
    "Approved Consent forms for both patient and surrogate",
  site_doa_log: "Site DOA log",
  site_training_log: "Site training log",
  protocol_signature_page: "Protocol Signature Page",
  reba_form: "REBA (Health Canada) Form",
  ctsi: "CTSI",
  qiu: "QIU",
  nol: "NOL",
  hc_div_five: "HC Div 5",
  site_monitoring: "Site Monitoring",
  // Other
  other: "Other",
  // Public category
  trial_protocol: "Trial protocol",
  physician_script: "Physician script",
  patient_information_sheet_text: "Patient information sheet text",
  patient_information_sheet_visual: "Patient information sheet visual",
  patient_consent_form: "Patient consent form",
  surrogate_consent_form: "Surrogate consent form",
  letter_of_bereavement: "Letter of bereavement",
  sae_form: "SAE form",
  // Training Category
  technical_admin_user_guide: "Technical Admin User Guide",
  site_pi_and_coordinators_user_guide: "Site PI & Coordinators User Guide",
  site_investigator_user_guide: "Site Investigator User Guide",
  technical_admin_user_training_presentation:
    "Technical Admin User Training Presentation",
  site_pi_and_coordinators_user_training_presentation:
    "Site PI & Coordinators User Training Presentation",
  site_investigator_user_training_presentation:
    "Site Investigator User Training Presentation",
  // Validation Category
  master_validation_plan: "Master Validation Plan",
  master_validation_report: "Master Validation Report",
  installation_qualication_plan: "Installation Qualication Plan",
  installation_qualication_report: "Installation Qualication Report",
  operational_qualitification_plan: "Operational Qualitification Plan",
  operational_qualitification_report: "Operational Qualitification Report",
  perfomance_qualification_plan: "Perfomance Qualification Plan",
  perfomance_qualification_report: "Perfomance Qualification Report",
  testing_plan: "Testing Plan",
  testing_log: "Testing Log",
  data_managemnt_plan: "Data Management Plan",
  system_architecture: "System Architecture",
  general_patient_document: "General patient document",
  site_contract: "Site Contract",
  site_siv_letter: "Site SIV Letter",
  site_ethic_submission: "Site Ethic submission",
  other_documents: "Other Documents",
};

export const categoryPublic = [
  "trial_protocol",
  "physician_script",
  "nol",
  "patient_information_sheet_text",
  "patient_information_sheet_visual",
  "patient_consent_form",
  "surrogate_consent_form",
  "letter_of_bereavement",
  "sae_form",
  "other",
];
export const categoryGeneral = ["other"];
export const categoryGeneralPrivate = ["other"];
export const categoryTraining = [
  "technical_admin_user_guide",
  "site_pi_and_coordinators_user_guide",
  "site_investigator_user_guide",
  "technical_admin_user_training_presentation",
  "site_pi_and_coordinators_user_training_presentation",
  "site_investigator_user_training_presentation",
  "other",
];
export const categoryPerSite = [
  "site_accreditation",
  "doctor_license",
  "training_completion_certificate",
  "cv",
  "gcp_certificates",
  "reb_ethics_approval_letter",
  "ethics_membership_list",
  "reb_ethics_correspondence",
  "approved_consent_form",
  "site_doa_log",
  "site_training_log",
  "protocol_signature_page",
  "reba_form",
  "ctsi",
  "qiu",
  "site_monitoring",
  "hc_div_five",
  "site_contract",
  "site_siv_letter",
  "site_ethic_submission",
  "other_documents",
];
export const categoryValidation = [
  "master_validation_plan",
  "master_validation_report",
  "installation_qualication_plan",
  "installation_qualication_report",
  "operational_qualitification_plan",
  "operational_qualitification_report",
  "perfomance_qualification_plan",
  "perfomance_qualification_report",
  "testing_plan",
  "testing_log",
  "data_managemnt_plan",
  "system_architecture",
  "other",
];
export const categoryPatientDocument = ["general_patient_document"];

class DocumentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const document = { ...values };
          document.name = get(document, "document_file.fileList", []).slice(
            -1
          ).name;
          document.category = "per_site";
          document.document_file = values.document_file.file;

          const formData = new FormData();

          if (values.document_file && values.document_file.file) {
            formData.append("document_file", values.document_file.file);
          }
          formData.append("name", values.name);
          formData.append("start_year", values.start_year.format("YYYY-MM-DD"));
          formData.append(
            "expiry_year",
            values.expiry_year ? values.expiry_year.format("YYYY-MM-DD") : null
          );
          formData.append("type", values.type);
          formData.append("category", values.category);
          formData.append("comments", values.comments);
          formData.append(
            "order_index",
            values.order_index ? values.order_index : 999
          );
          if (values.category === "per_site") {
            formData.append("site_id", values.site_id);
          }
          if (values.category === "public") {
            formData.append("site_id", values.site_id ? values.site_id : null);
          }

          if (this.props.patient) {
            formData.append(
              "subject_profile_id",
              this.props.patient.profile.id
            );

            formData.append("site_id", this.props.patient.site.id);
          }

          if (this.props.id) {
            if (this.props.patient) {
              await updatePatientProfileDocumentRequest(
                this.props.id,
                formData
              );
            } else {
              await updateDocumentRequest(this.props.id, formData);
            }
          } else {
            if (this.props.patient) {
              await createPatientProfileDocumentRequest(formData);
            } else {
              await createDocumentRequest(formData);
            }
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  render() {
    const { isLoading, requestResult, sites } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      documentUpdatePermission,
      documentCreatePermission,
      id,
      isNew,
      withPatient,
    } = this.props;

    const categoryVal = getFieldValue("category");

    const isEditable = id ? documentUpdatePermission : documentCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              "Add New Document"
            ) : (
              ""
            )}
          </h4>

          {!get(this.props, "patient.profile.id") && withPatient && (
            <Row>
              <Col>
                <Alert
                  type="error"
                  message="Note: You must create the profile for this subject in order to upload the documents!"
                />
                <br />
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col>
              <label>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      disabled={!isEditable}
                      accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url
                          ? "Change file"
                          : "Add New Document"}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue("document_file") &&
                this.props.url && (
                  <div>
                    <FileLink url={this.props.url} text="File preview" />
                    <br />
                    <br />
                  </div>
                )}
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Index</b>
                <Form.Item style={{ marginBottom: "12px" }}>
                  {getFieldDecorator(`order_index`, {
                    initialValue: get(this.props, "order_index", ""),
                  })(<InputNumber disabled={!isEditable} placeholder="999" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Category</b>
                <Form.Item>
                  {getFieldDecorator("category", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "category"),
                  })(
                    this.props.patient ? (
                      <Select
                        disabled={!isEditable}
                        onChange={this.onCategoryChange}
                      >
                        <Option
                          value="patient_documents"
                          disabled={!this.props.documentGeneralReadPermission}
                        >
                          Patient documents
                        </Option>
                      </Select>
                    ) : (
                      <Select
                        disabled={!isEditable}
                        onChange={this.onCategoryChange}
                      >
                        <Option
                          value="public"
                          disabled={!this.props.documentPublicReadPermission}
                        >
                          Public
                        </Option>
                        <Option
                          value="general"
                          disabled={!this.props.documentGeneralReadPermission}
                        >
                          Central Shared
                        </Option>
                        <Option
                          value="general_private"
                          disabled={
                            !this.props.documentGeneralPrivateReadPermission
                          }
                        >
                          Central Private
                        </Option>
                        <Option
                          value="per_site"
                          disabled={!this.props.documentPerSiteReadPermission}
                        >
                          Site Specific
                        </Option>
                        <Option
                          value="training"
                          disabled={!this.props.documentTrainingReadPermission}
                        >
                          Training
                        </Option>
                        <Option
                          value="validation"
                          disabled={
                            !this.props.documentValidationReadPermission
                          }
                        >
                          Validation
                        </Option>
                      </Select>
                    )
                  )}
                </Form.Item>
              </label>
            </Col>

            {categoryVal === "public" && (
              <Col lg={12}>
                <label>
                  <b>Site ID</b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      initialValue: get(this.props, "site_id", null),
                    })(
                      <Select
                        disabled={!isEditable}
                        placeholder="Select Site ID"
                        style={{ width: "100%" }}
                        allowClear
                      >
                        <Option key={0} value={null}>
                          General
                        </Option>
                        {sites.map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}

            {categoryVal === "per_site" && (
              <Col lg={12}>
                <label>
                  <b>Site ID</b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      rules: [{ required: true, message: "Required" }],
                      initialValue: get(this.props, "site_id"),
                    })(
                      <Select
                        disabled={!isEditable}
                        placeholder="Select Site ID"
                        style={{ width: "100%" }}
                        allowClear
                      >
                        {sites.map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>
          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>Document type</b>
                <Form.Item>
                  {getFieldDecorator("type", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "type"),
                  })(
                    <Select disabled={!isEditable}>
                      {(() => {
                        let documentTypeList = [];

                        if (categoryVal === "public") {
                          documentTypeList = categoryPublic;
                        }
                        if (categoryVal === "general") {
                          documentTypeList = categoryGeneral;
                        }
                        if (categoryVal === "general_private") {
                          documentTypeList = categoryGeneralPrivate;
                        }
                        if (categoryVal === "per_site") {
                          documentTypeList = categoryPerSite;
                        }
                        if (categoryVal === "training") {
                          documentTypeList = categoryTraining;
                        }
                        if (categoryVal === "validation") {
                          documentTypeList = categoryValidation;
                        }
                        if (categoryVal === "patient_documents") {
                          documentTypeList = categoryPatientDocument;
                        }

                        return documentTypeList.map((key) => (
                          <Option key={key} value={key}>
                            {documentTypes[key]}
                          </Option>
                        ));
                      })()}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>Document Name</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "name"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Year</b>
                <Form.Item>
                  {getFieldDecorator("start_year", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "start_year")
                      ? moment(get(this.props, "start_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Renewal/expiry year</b>
                <Form.Item>
                  {getFieldDecorator("expiry_year", {
                    initialValue: get(this.props, "expiry_year")
                      ? moment(get(this.props, "expiry_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col>
              <label>
                <b>Comments</b>
                <Form.Item>
                  {getFieldDecorator("comments", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "comments"),
                  })(<Input.TextArea disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                  disabled={
                    !get(this.props, "patient.profile.id") && withPatient
                  }
                >
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  documentCreatePermission: getDocumentCreatePermission(state),
  documentUpdatePermission: getDocumentUpdatePermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "user" })(
  connect(mapStateToProps, mapDispatchToProps)(DocumentForm)
);



// WEBPACK FOOTER //
// ./src/components/DocumentForm/DocumentForm.js